import { render, staticRenderFns } from "./SideBarPanel.vue?vue&type=template&id=4c0c014f&scoped=true&"
import script from "./SideBarPanel.vue?vue&type=script&lang=js&"
export * from "./SideBarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SideBarPanel.vue?vue&type=style&index=0&id=4c0c014f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c014f",
  null
  
)

export default component.exports